const styles = {
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  gridContainer: {
    height: "100%",
    maxHeight: "100%",
    width: "100%",
    overflowY: "auto",
    maxWidth: "100%",
    flexDirection: "column",
    flexWrap: "nowrap",
    pt: 6,
  },
  loadingContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  logoContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  buttonsContainer: {
    pt: 4,
    pb: 4,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
};

export default styles;
